
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';
import Discount from './Discount';
import Venues from './Venues';
import Venues2 from './Venues2';
import Venues3 from './Venues3';

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/location" element={<Venues />} />
          <Route path="/location2" element={<Venues2 />} />
          <Route path="/location3" element={<Venues3 />} />
          <Route path="/Discount" element={<Discount />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
